module.exports = __webpack_public_path__ + "img/new-link.17389e40.svg";